import { createFileRoute } from "@tanstack/react-router";
import TmsOverviewPage from "@/pages/TmsOverviewPage";
export const Route = createFileRoute("/services/tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Therapy Services in Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy overview at Neuro Wellness in Coral Springs, FL. Learn how transcranial magnetic stimulation treats depression. Free consultation available.",
        },
        {
          property: "og:title",
          content: "TMS Therapy Services in Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy overview at Neuro Wellness in Coral Springs, FL. Learn how transcranial magnetic stimulation treats depression. Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsOverviewPage />;
}
